import React from "react";

/**
 * Official third-party payment BRAND mark (Apple Pay, Google Pay, Visa, ...).
 *
 * These are trademarks — we never redraw or approximate them. Drop each brand's
 * OFFICIAL asset into /public/brands/<key>.svg (per that brand's own
 * payment-mark / brand guidelines: correct colors, proportions, clear space)
 * and it renders automatically. Until the official asset is added, a clearly
 * labeled placeholder shows in its place.
 */
const BRAND_LABELS = {
  applepay: "Apple Pay",
  googlepay: "Google Pay",
  visa: "Visa",
  mastercard: "Mastercard",
  paypal: "PayPal",
  venmo: "Venmo",
  bitcoin: "Bitcoin",
  tether: "Tether (USDT)",
  ethereum: "Ethereum",
  usdc: "USDC",
};

export function PaymentBrand({ brand, height = 20, className = "" }) {
  const label = BRAND_LABELS[brand] || brand;
  const src = `${process.env.PUBLIC_URL || ""}/brands/${brand}.svg`;
  const [assetOk, setAssetOk] = React.useState(true);

  if (assetOk) {
    return (
      <img
        src={src}
        alt={label}
        data-brand-asset={brand}
        onError={() => setAssetOk(false)}
        style={{ height, width: "auto", display: "inline-block" }}
        className={className}
      />
    );
  }

  return (
    <span
      data-brand-asset={brand}
      title={`${label} — drop official asset at /brands/${brand}.svg`}
      className={`inline-flex items-center justify-center rounded border border-dashed border-surface-border bg-surface-4 px-2 text-[11px] font-medium leading-none text-muted-foreground ${className}`}
      style={{ height }}
    >
      {label}
    </span>
  );
}

export default PaymentBrand;
